import { getIdFromVanityUrl } from '@client/listeners/utils/router';
import { showError } from '@client/listeners/lib/alerts';
import { startFetchPublicActDetails, unsubscribeAct } from '@client/slices/entities/acts.reducer';
import type { AddListener } from '@client/listeners/lib';

export const withActListeners = (addListener: AddListener) => [
  addListener({
    actionCreator: startFetchPublicActDetails,
    effect: async (action, listenerApi) => {
      let actId = action.payload;

      try {
        if (!actId) {
          await getIdFromVanityUrl(listenerApi);

          return;
        }

        const firebase = window.Firebase;

        firebase.SDK.Acts.listen(
          actId,
          null,
          {
            modifier: { publicFetched: true },
          },
        );
      } catch (e) {
        console.error(e);
        showError(e);
      }
    },
  }),

  addListener({
    actionCreator: unsubscribeAct,
    effect: async (action, listenerApi) => {
      let actId = action.payload;

      try {
        if (!actId) {
          await getIdFromVanityUrl(listenerApi);

          return;
        }

        const firebase = window.Firebase;

        firebase.SDK.Acts.unsubscribe(actId);
      } catch (e) {
        console.error(e);
      }
    },
  }),
];
